import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiAlertTriangle,FiShield,FiZap}=FiIcons;

const HeroSection=()=> {
  const containerVariants={
    hidden: {opacity: 0},
    visible: {
      opacity: 1,
      transition: {staggerChildren: 0.3,delayChildren: 0.2}
    }
  };

  const itemVariants={
    hidden: {y: 30,opacity: 0},
    visible: {
      y: 0,
      opacity: 1,
      transition: {duration: 0.8,ease: "easeOut"}
    }
  };

  const floatingAnimation={
    y: [-10,10,-10],
    transition: {duration: 4,repeat: Infinity,ease: "easeInOut"}
  };

  return (
    <section className="relative py-20 px-6">
      <div className="container mx-auto max-w-4xl text-center">
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="space-y-8"
        >
          <motion.div variants={itemVariants} className="relative">
            <motion.div animate={floatingAnimation} className="inline-block">
              <div className="relative">
                <motion.div 
                  className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full blur-xl opacity-30"
                  animate={{scale: [1,1.2,1]}}
                  transition={{duration: 3,repeat: Infinity}}
                />
                <div className="relative bg-gradient-to-r from-blue-600 to-indigo-600 p-6 rounded-full">
                  <SafeIcon icon={FiAlertTriangle} className="w-16 h-16 text-white" />
                </div>
              </div>
            </motion.div>
          </motion.div>

          <motion.div variants={itemVariants} className="space-y-4">
            <h1 className="text-5xl md:text-7xl font-bold">
              <span className="bg-gradient-to-r from-blue-400 via-indigo-400 to-violet-400 bg-clip-text text-transparent">
                Abuse
              </span>
              <br />
              <span className="bg-gradient-to-r from-emerald-400 to-teal-500 bg-clip-text text-transparent">
                Reporting
              </span>
            </h1>
            <motion.p 
              className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto leading-relaxed"
              variants={itemVariants}
            >
              Melden Sie verdächtige Aktivitäten, Spam oder Missbrauch. 
              <br />
              <span className="text-blue-400 font-semibold">Visio Wasacon GmbH</span> nimmt jeden Bericht ernst und handelt schnell.
            </motion.p>
          </motion.div>

          <motion.div 
            variants={itemVariants}
            className="flex justify-center space-x-8 pt-8"
          >
            {[
              {icon: FiShield,label: "Sicher",color: "from-emerald-500 to-teal-600"},
              {icon: FiZap,label: "Schnell",color: "from-blue-500 to-indigo-600"},
              {icon: FiAlertTriangle,label: "Zuverlässig",color: "from-violet-500 to-purple-600"}
            ].map((item,index)=> (
              <motion.div 
                key={index}
                className="flex flex-col items-center space-y-2"
                whileHover={{scale: 1.1,y: -5}}
                transition={{type: "spring",stiffness: 300}}
              >
                <div className={`bg-gradient-to-r ${item.color} p-3 rounded-full shadow-lg shadow-blue-900/20`}>
                  <SafeIcon icon={item.icon} className="w-6 h-6 text-white" />
                </div>
                <span className="text-gray-400 text-sm font-medium">{item.label}</span>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>

      {/* Animated background elements */}
      <motion.div 
        className="absolute top-20 left-10 w-20 h-20 bg-gradient-to-r from-blue-500/20 to-indigo-500/20 rounded-full blur-xl"
        animate={{x: [0,100,0],y: [0,-50,0],scale: [1,1.5,1]}}
        transition={{duration: 8,repeat: Infinity,ease: "easeInOut"}}
      />
      <motion.div 
        className="absolute bottom-20 right-10 w-32 h-32 bg-gradient-to-r from-emerald-500/10 to-teal-500/10 rounded-full blur-xl"
        animate={{x: [0,-80,0],y: [0,30,0],scale: [1,0.8,1]}}
        transition={{duration: 6,repeat: Infinity,ease: "easeInOut"}}
      />
    </section>
  );
};

export default HeroSection;